import { TableClass } from '../../../world/spa/libs/classes';

export default {
	contactsContactType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'user',
				it: "Utente",
				en: "User"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'work',
				it: "Azienda",
				en: "Work"
			}
		});
	},
	contactsNotificationCode() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'referentAssignment',
				it: "Assegnamento referente",
				en: "Referent assignment"
			}
		});
	}
}
